var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21Z",
    fill: "#EDE6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.379 21.0071C30.379 21.1549 30.35 21.3013 30.2935 21.438C30.2369 21.5746 30.154 21.6987 30.0494 21.8033C29.9449 21.9078 29.8208 21.9907 29.6841 22.0473C29.5475 22.1038 29.4011 22.1329 29.2532 22.1328L22.127 22.1314L22.127 29.2562C22.1198 29.5496 21.9982 29.8286 21.7882 30.0337C21.5781 30.2387 21.2962 30.3535 21.0027 30.3536C20.7092 30.3537 20.4272 30.239 20.217 30.0341C20.0069 29.8292 19.8851 29.5503 19.8777 29.2569L19.8777 22.1321L12.7529 22.1321C12.4616 22.1218 12.1856 21.9988 11.9832 21.7891C11.7807 21.5794 11.6676 21.2993 11.6676 21.0078C11.6676 20.7163 11.7807 20.4361 11.9832 20.2264C12.1856 20.0167 12.4616 19.8937 12.7529 19.8835L19.877 19.8813L19.877 12.7565C19.877 12.4582 19.9955 12.172 20.2065 11.961C20.4175 11.7501 20.7036 11.6315 21.002 11.6315C21.3004 11.6315 21.5865 11.7501 21.7975 11.961C22.0085 12.172 22.127 12.4582 22.127 12.7565L22.1277 19.882H29.2525C29.4003 19.882 29.5466 19.9111 29.6831 19.9677C29.8195 20.0242 29.9436 20.1071 30.048 20.2116C30.1525 20.316 30.2354 20.44 30.2919 20.5765C30.3484 20.713 30.3775 20.8593 30.3775 21.0071H30.379Z",
    fill: "#222229"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.1382d59ef1fd18ee6e6fabed6e14baaa.svg";
export { ForwardRef as ReactComponent };